import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (!localStorage.getItem("cookie_consent")) {
      this.bannerTarget.style.display = "block"
    }
  }

  accept() {
    localStorage.setItem("cookie_consent", "accepted")
    this.bannerTarget.style.display = "none"
  }

  decline() {
    localStorage.setItem("cookie_consent", "declined")
    this.bannerTarget.style.display = "none"
  }
}
